import { useContext } from 'react';

import { CollapsibleContext } from '../collapsible.context.ts';

export const useClipped = (): boolean | undefined => useContext(CollapsibleContext).clipped;
